export enum CalculatorRoutesEnum {
  LOAN = 'common',
  DEPOSIT_FAMILY = 'deposit-calculator-family',
  DEPOSIT_CHILDREN = 'deposit-calculator-children',
  DEPOSIT_ACCUMULATION = 'deposit-calculator-accumulation',
  DEPOSIT_CLASSIC = 'deposit-calculator-classic',
  DEPOSIT_BUSINESS = 'business-deposit-calculator',
  COMPARE = 'compare',
}
